import { createAction } from 'react-async-client';
import {
    APPROVE_PROJECT,
    REJECT_PROJECT,

    GET_APPROVAL_PROJECT_LIST,
    SET_APPROVAL_PROJECT_LIST_SORT,
    SET_APPROVAL_PROJECT_LIST_SELECTED,
    SET_APPROVAL_PROJECT_LIST_PAGINATION,
    GET_APPROVAL_PROJECT_COUNTERS
} from '../constants/actionTypes';

export const approveProject = createAction(APPROVE_PROJECT);
export const rejectProject = createAction(REJECT_PROJECT);

export const getApprovalProjectList = createAction(GET_APPROVAL_PROJECT_LIST);
export const setApprovalProjectListSort = createAction(SET_APPROVAL_PROJECT_LIST_SORT);
export const setApprovalProjectListSelected = createAction(SET_APPROVAL_PROJECT_LIST_SELECTED);
export const setApprovalProjectListPagination = createAction(SET_APPROVAL_PROJECT_LIST_PAGINATION);
export const getApprovalProjectCounters = createAction(GET_APPROVAL_PROJECT_COUNTERS);
